
class QueryParams {
    constructor() { }

    getAll() {
        return getQueryParams();
    }

    get(name: string) {
        return getQueryParams()[name];
    }
}

let getQueryParams = () => {
    let paramsObj: any = {};
    const query = window.location.search.substr(1);
    const params = query.split("&");
    params.forEach(function (param) {
        try {
            var kv = param.split("=");
            paramsObj[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        } catch (e) { }
    });
    return paramsObj;
}

export default QueryParams;